import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Invoice } from '../models/Invoice.model';
import { environment } from "environments/environment";import { Observable } from 'rxjs';
 let __URL_API__  = `${environment.URL_API}`; 

@Injectable({providedIn: 'root'})
export class InvoiceService {

    constructor(private _http: HttpClient) { }


    getDetailInvoices(filter: 'invoiceunpaid' | 'invoicepaid' , skip: number = 0, limit?: number): Observable<{ count: number, data: Invoice[]}> {
            var params = new HttpParams()
                .set('LeftToPayFilter', filter)
                .set('skip', String(skip))
                .set('limit', String(limit));
            
            if (limit) {
                params.set('limit', String(limit));
            }

            return this._http.get<{ count: number, data: Invoice[]}>(__URL_API__ + 'api/invoices',{params});
    }


    async getnbUnpayedInvoices(myfilter: string): Promise<number> {
        try {

            let response = await this._http.get(__URL_API__ + 'api/Invoices/count?InDebit=false&LeftToPayFilter=' +myfilter).toPromise();

            return response as  number ;
        }
        catch (error) {
            return await this.handleError(error);
        }
    }


    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

}